import { Get, Remove, Set } from "../../../../../Request";
export const FormSubmit = async data => {
  await Set({
    url: "/adminmanagment/newadmin",
    data: data,
  });
};

export const GetData = async (pageNumber, limit = 15, filter) => {
  return await Get({
    url: "/adminmanagment/list",
    data: {
      limit: limit,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/adminmanagment/destroy",
    data: data,
  });
};

export const EditData = async data => {
  await Set({
    url: "/adminmanagment/update",
    data: data,
  });
};
